export const GAME_TITLE = "சொல் என்ன வகை?";
export const MAX_MISTAKES = 4;
